module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "viewBox": _vm.viewBox,
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [(_vm.gender === 'M') ? [(_vm.isCurator) ? _c('mentoring-old-man-icon') : (_vm.isMentor) ? _c('mentoring-man-icon') : _c('mentoring-boy-icon')] : (_vm.gender === 'W') ? [(_vm.isCurator) ? _c('mentoring-old-woman-icon') : (_vm.isMentor) ? _c('mentoring-woman-icon') : _c('mentoring-girl-icon')] : [(_vm.isCurator || _vm.isMentor || _vm.asCurator) ? _c('mentoring-dummy-icon') : _c('mentoring-bag-icon')]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7be26d05","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/avatar/components/stub/MentoringAvatarStub.vue
// module id = 9e6f081cfb62139b5b0e
// module chunks = 89